import { Box, styled } from '@mui/material';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';

export const HeaderScrollWrapper = styled(Box)({
  width: '100%',
  overflowX: 'auto',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
});

export const HeaderContainer = styled(Box)({
  display: 'grid',
  backgroundColor: '#2F736E',
  borderRadius: '8px',
});

export const ParentCell = styled(Box)({
  padding: '0.5rem 0.5rem',
  fontWeight: 700,
  fontSize: '0.875rem',
  lineHeight: '1rem',
  color: '#F6F8F9',
  display: 'flex',
  alignItems: 'center',
  borderLeft: '1px solid #737F86',
  '&:first-of-type': {
    borderLeft: 'none',
  },
});

export const ChildCell = styled(Box)({
  padding: '0.25rem 0.5rem',
  fontWeight: 700,
  fontSize: '0.75rem',
  lineHeight: '1rem',
  color: '#F6F8F9',
  borderLeft: '1px solid #737F86',
  borderTop: '1px solid #737F86',
});

export const StickyParentCell = styled(ParentCell)({
  position: 'sticky',
  zIndex: 2,
  backgroundColor: '#2F736E',
  '&:first-of-type': {
    borderTopLeftRadius: '8px',
    borderBottomLeftRadius: '8px',
  },
});

export const ExpandCollapseButton = styled('button')({
  type: 'button',
  border: 'none',
  background: 'none',
  cursor: 'pointer',
  padding: 0,
  marginLeft: '4px',
  display: 'inline-flex',
  alignItems: 'center',
  color: '#9AD6D1',
});

export const CollapseIcon = () => (
  <>
    <ArrowRightIcon sx={{ color: '#162C36' }} />
    <ArrowLeftIcon sx={{ color: '#162C36', marginLeft: '-10px' }} />
  </>
);

export const ExpandIcon = () => (
  <>
    <ArrowLeftIcon sx={{ color: '#162C36' }} />
    <ArrowRightIcon sx={{ color: '#162C36', marginLeft: '-10px' }} />
  </>
);
